













import Vue from "vue";

interface Journals {
  name: string;
  img?: string;
  about: string[];
  mision?: string;
}

export interface HomeComponentData {
  journals: Journals[];
}

const Journals = Vue.extend({
  data(): HomeComponentData {
    return {
      journals: [
        // {
        //   name: 'Institución Universitaria Colegio Mayor del Cauca',
        //   img: '/images/journals/ColegioMayor.jpg',
        //   about: [
        //     'El Colegio Mayor del Cauca creado por la Ley 48 de 1945, inició su labor académica el 13 de noviembre de 1967. En el año 2008 se expide la Resolución 5858 por medio de la cual se modifica su carácter académico a INSTITUCIÓN UNIVERSITARIA. Es un Establecimiento Público del orden departamental, de carácter académico, con personería jurídica, autonomía administrativa, patrimonio independiente y con domicilio en la ciudad de Popayán.',
        //     'En el año 2021, Institución Universitaria Colegio Mayor del Cauca imparte 5 carreras universitarias, 7 posgrados y 5 carreras cortas. Entre sus carreras universitarias, puedes estudiar alguna de sus 4 pregrados y 1 ingeniería.',
        //   ],
        // },
        {
          name: "Revista Colombiana de Tecnologías de Avanzada",
          img: "/images/revistas/upamplona.png",
          about: [
            "La Revista Colombiana de Tecnologías de Avanzada tiene como propósito la difusión de conocimientos en la áreas de las tecnologías de avanzada. Se propone publicar artículos generales y artículos especializados donde se traten temas desde Control automático, Automatización, Procesamiento Digital de Señales, Electrónica, Electrica, Telecomunicaciones, Sistemas y áreas afines a la ingeniería.",
            "Esta revista es un punto de encuentro entre los universitarios, ingenieros e investigadores tanto de la Facultad como de otras Universidades del País y el extranjero, que tienen lazos de trabajos con la Universidad de Pamplona, se les brinda la posibilidad de que se publiquen sus resultados investigativos.",
          ],
        },
        {
          name: "Revista Facultad de Ingeniería",
          img: "/images/revistas/revistauptc.png",
          about: [
            "Creada en 1986, es una revista científica internacional de acceso abierto, dedicada a diversas subáreas de la ingeniería, tales como: Ing. Ambiental, Ing. Electrónica, Ing. Metalúrgica y de Materiales, Ing. de Sistemas y Computación, entre otras. La Revista es editada por la Universidad Pedagógica y Tecnológica de Colombia y tiene como objetivo contribuir a la difusión de la investigación de impacto, a través de la publicación de artículos, en inglés y español, sobre investigación e innovación, reseñas y reflexiones, que representan una producción original en el campo de la ingeniería.",
          ],
        },
        {
          name: "Tecnológicas",
          img: "/images/revistas/tecnologicas.png",
          about: [
            "TecnoLógicas es una revista científica multidisciplinaria de acceso abierto que publica artículos en diferentes campos de la ingeniería y la tecnología aplicada. TecnoLógicas publica artículos originales de investigación y de revisión en inglés o español. La revista opera bajo un modelo de publicación continua con tres números al año. Los artículos se seleccionan a través de una revisión por pares doble ciego, verificando estrictamente su conformidad con los aspectos éticos de la publicación científica. La publicación de TecnoLógicas está financiada por el Instituto Tecnológico Metropolitano de Medellín (Colombia).",
          ],
        },
      ],
    };
  },
});

export default Journals;
